import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import { isEmptyValue } from '@jutro/data';
import { getOptionCode } from './widgets/inputs/availableValues';
export const SPACE_BAR = ' ';
export const makeHandleRadioButtonKeyDown = focusTrigger => (evt, props, handleAvailableValuesValueChange) => {
  const model = props.model,
    path = props.path,
    value = props.value,
    availableValues = props.availableValues;
  const selectedElementIndex = _findIndexInstanceProperty(availableValues).call(availableValues, el => !isEmptyValue(value) && getOptionCode(el) === value.toString());
  const handleMove = eventMap[evt.key];
  if (handleMove) {
    evt.preventDefault();
  }
  const targetIndex = handleMove ? handleMove(selectedElementIndex, availableValues) : -1;
  if (targetIndex >= 0) {
    const optionCode = getOptionCode(availableValues[targetIndex]);
    handleAvailableValuesValueChange(optionCode, model || path);
    focusTrigger === null || focusTrigger === void 0 ? void 0 : focusTrigger(evt.currentTarget, optionCode);
  }
};
const handleMoveDown = (selectedElementIndex, availableValues) => (selectedElementIndex + 1) % availableValues.length;
const handleMoveUp = (selectedElementIndex, availableValues) => selectedElementIndex === 0 ? availableValues.length - 1 : (selectedElementIndex - 1) % availableValues.length;
const eventMap = {
  SPACE_BAR: () => -1,
  ArrowDown: handleMoveDown,
  ArrowRight: handleMoveDown,
  ArrowUp: handleMoveUp,
  ArrowLeft: handleMoveUp
};
export const getTabIndex = index => index === 0 ? 0 : -1;